<script setup lang="ts">
import {BalancerProvider} from 'vue-wrap-balancer'
useZodConfig()

const {fetchNavData} = useNavData()
useNewsletter()

await useAsyncData('nav-data', async () => {
  await fetchNavData()
})

const config = useRuntimeConfig()
const {localeProperties} = useI18n()

useHead({
  htmlAttrs: {
    lang: (localeProperties.value.iso as string) ?? 'en',
  },
})

useSchemaOrg([
  defineWebSite({
    name: 'Webamboos',
    logo: `${config.public.baseUrl}/favicon.png`,
  }),
  defineWebPage(),
])
</script>

<template>
  <NuxtLayout>
    <div class="min-h-screen overflow-x-hidden">
      <BalancerProvider>
        <NuxtLoadingIndicator class="hidden lg:!block" color="#0D9488" />
        <NuxtPage />
      </BalancerProvider>
    </div>
  </NuxtLayout>
</template>
